import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.945 11a9 9 0 1 1 -3.284 -5.997l-2.655 2.392a5.5 5.5 0 1 0 2.119 6.605h-4.125v-3h7.945","key":"svg-0"}]]

/**
 * IconBrandGoogle
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZ29vZ2xlIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0yMC45NDUgMTFhOSA5IDAgMSAxIC0zLjI4NCAtNS45OTdsLTIuNjU1IDIuMzkyYTUuNSA1LjUgMCAxIDAgMi4xMTkgNi42MDVoLTQuMTI1di0zaDcuOTQ1IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-google
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandGoogle = createReactComponent('outline', 'brand-google', 'BrandGoogle', __iconNode);

export default IconBrandGoogle;